<template>
  <el-container id="scene">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding:15px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <!--          <span style="margin-left:0;color: #ffffff; font-size: 13px">-->
          <!--            <el-radio-group v-model="tab_xz" size="small" @change="onXz">-->
          <!--              <el-radio-button label="手动触发"></el-radio-button>-->
          <!--              <el-radio-button label="设备触发"></el-radio-button>-->
          <!--            </el-radio-group>-->
          <!--          </span>-->
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
              placeholder="输入场景名称查询"
              style="width:10vw;"
              prefix-icon="el-icon-search"
              clearable
              @change="getScene()"
              v-model="scan_name">
            </el-input>
          </span>
          <el-button @click="addScene" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:auto;margin-right:15px">
            新增联动
          </el-button>
        </div>
        <div class="grid-box" :style="divStyle">
          <div class="grid-item" v-for="tab in fil_tabData" :style="{background:tab.bj}">
            <div style="height:200px;width:100%;line-height:0.3;align-items:center;text-align:center">
              <p style="width:100%;margin-top:25px;font-size:16px">{{ tab.name }}</p>
              <!--              <p style="width:100%;margin-bottom:25px;font-size:15px;color: #8E8E8E">{{ tab.description }}</p>-->
              <p style="width:100%;margin-bottom:25px;font-size:15px;color: #8E8E8E">
                {{ tab.buildName }}/{{ tab.floorName }}/{{ tab.roomName }}
              </p>
              <el-switch
                style="margin-top:10px"
                v-model="tab.enable"
                @change="changeScene(tab)"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
              <div
                style="display:flex;height:140px;width:100%;line-height:0.3;align-items:center;justify-content:center;">
                <el-button @click="change_dvc(tab)" type="text" size="small" icon="el-icon-edit"
                           style="color:#72767b;font-size:20px;"/>
                <el-button @click="del_Scene(tab)" type="text" size="small" icon="el-icon-delete"
                           style="color:#72767b;font-size:20px;margin-left:25px"/>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          style="float:right; margin-right:0.5vw;margin-top:5px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange1"
          :current-page="page"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
      title="删除提示"
      :visible.sync="daiDelScene"
      width="30%">
      <span>确定删除该定时吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelScene = false">取 消</el-button>
        <el-button type="primary" @click=delScene()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name: "scene",
  data() {
    return {
      h_text: "联动管理",
      li_h_text: [
        {"text": "联动策略", "colour": "#B7B7B7", "pages": ""},
      ],
      tabData: [], //{'a': 1, "bj": "#EEF4FF"}, {'a': 2, "bj": "#EDEDED"}
      divStyle: {
        marginLeft: '0',
        marginTop: '20px',
        maxHeight: window.innerHeight - 170,
      },
      tab_xz: '手动触发',
      edi_pwr: [],
      li_pwr: [{
        value: '1',
        label: '打开'
      }, {
        value: '2',
        label: '关闭'
      }], /*角色列表*/
      li_Scene: [],
      scan_name: "",
      page: 1,
      pageSize: 10,
      total: 0,
      maxHeight: window.innerHeight - 225,
      defHead: [
        {'key': "序号", 'val': "item", "w": "200px"},
        {'key': "定时名称", 'val': "nickName", "w": "auto"},
        {'key': "定时时间", 'val': "SceneName", "w": "auto"},
        {'key': "执行周期", 'val': "authName", "w": "auto"},
        {'key': "执行内容", 'val': "SceneState", "w": "auto"},
        {'key': "使能开关", 'val': "SceneState", "w": "auto"},
      ],
      edi_status: "",
      li_status: [{
        value: '启用',
        label: '启用'
      }, {
        value: '禁用',
        label: '禁用'
      }],
      edi_wx: "",
      li_wx: [{
        value: '是',
        label: '是'
      }, {
        value: '否',
        label: '否'
      }],
      post_head: {},
      daiDelScene: false,
    }
  },
  methods: { /*方法存放*/
    onXz() {
      console.log(this.tab_xz)
    },
    change_dvc(row) {
      console.log(row)
      this.$router.push({ /*路由跳转传值*/
        path: '/home/sceneTlinkSon',
        query: {
          key: 'change',
          id: row.id,
          name: row.name,
          cycle: row.cycle,
          description: row.description,
          trigger: JSON.stringify(row.trigger),
          condition: JSON.stringify(row.condition),
          exception: JSON.stringify(row.exception),
          scene: JSON.stringify(row.scene),
          roomId: row.roomId,
          floorId: row.floorId,
          buildId: row.buildId,
          roomName: row.roomName,
          floorName: row.floorName,
          buildName: row.buildName,
        }
      })
    },
    addScene() {
      this.$router.push({ /*路由跳转传值*/
        path: '/home/sceneTlinkSon',
        query: {key: 'add'}
      })
    },
    changeScene(row) {
      const params = {
        'id': row.id,
        'enable': row.enable,
        'projectId': localStorage.getItem("projectId")
      }
      const headers = {
        'token': localStorage.getItem("token")
      }
      console.log(params)
      this.$api.post(this.$urls.ip + this.$urls.enableAuto, params, headers)
        .then(res => {
          console.log(res.data)
          this.$message.success("修改成功")
        })
        .catch(error => {
          console.log(error)
          if (error) {
            this.$message.error("修改失败")
          }
        })
    },
    del_Scene(row) {
      this.id = row.id
      this.daiDelScene = true
    },
    delScene() {
      const params = {
        'id': this.id,
        'projectId': localStorage.getItem("projectId")
      }
      const headers = {
        'token': localStorage.getItem("token")
      }
      console.log(params)
      this.$api.post(this.$urls.ip + this.$urls.delAuto, params, headers)
        .then(res => {
          console.log(res.data.data)
          this.$message.success("删除成功")
          this.daiDelScene = false
          this.getScene()
        })
        .catch(error => {
          console.log(error)
          if (error) {
            this.$message.error("删除失败")
          }
        })
    },
    tableYs({row, column, rowIndex, columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282'
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getScene();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getScene();
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus()
      } else {
        this.$refs.select1.blur()
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus()
      } else {
        this.$refs.select2.blur()
      }
    },
    show_change3(item) {
      if (item) {
        this.$refs.select3.focus()
      } else {
        this.$refs.select3.blur()
      }
    },
    init_View() {
      let data = this.li_Scene
      let li_d = []
      let j = 1
      for (let i = 0; i < data.length; i++) {
        let d = {
          item: j,
          id: data[i]['id'],
          name: data[i]['name'],
          description: data[i]['description'], /*描述*/
          enable: data[i]['enable'], /*开关*/
          cycle: data[i]['cycle'], /*开关*/
          roomId: data[i]['roomId'],
          bj: "#EEF4FF",
          trigger: [],
          condition: [],
          exception: [],
          scene: [],
        }
        d['floorId'] = -1
        d['buildId'] = -1
        d['roomName'] = ""
        d['floorName'] = ""
        d['buildName'] = ""
        if (data[i]['room']) {
          d['roomName'] = data[i]['room']['name']
          d['floorId'] = data[i]['room']['floorId']
          if (data[i]['room']['floor']) {
            d['floorName'] = data[i]['room']['floor']['name']
            d['buildId'] = data[i]['room']['floor']['buildingId']
            if (data[i]['room']['floor']['building']) {
              d['buildName'] = data[i]['room']['floor']['building']['name']
            }
          }
        }
        for (let k = 0; k < data[i]['trigger'].length; k++) {
          d["trigger"].push({
            "id": k,
            "name": data[i]['trigger'][k]["name"],
            "edi_tjcf": data[i]['trigger'][k]["id"],
            "projectId": data[i]['trigger'][k]["projectId"],
          })
        }
        for (let k = 0; k < data[i]['condition'].length; k++) {
          d["condition"].push({
            "id": k,
            "name": data[i]['condition'][k]["name"],
            "edi_tjys": data[i]['condition'][k]["id"],
            "projectId": data[i]['condition'][k]["projectId"],
          })
        }
        for (let k = 0; k < data[i]['exception'].length; k++) {
          d["exception"].push({
            "id": k,
            "name": data[i]['exception'][k]["name"],
            "edi_tjtime": data[i]['exception'][k]["id"],
            "projectId": data[i]['exception'][k]["projectId"],
          })
        }
        for (let k = 0; k < data[i]['scene'].length; k++) {
          d["scene"].push({
            "id": k,
            "name": data[i]['scene'][k]["name"],
            "edi_scene": data[i]['scene'][k]["id"],
            "projectId": data[i]['scene'][k]["projectId"],
          })
        }
        d["SceneState"] = d["SceneStateId"] === 1; /*启用使能开关*/
        li_d.push(d)
        j += 1
      }
      console.log(li_d)
      this.tabData = li_d
    },
    getScene() {
      const params = {
        'page': this.page,
        'pageSize': this.pageSize,
        'projectId': localStorage.getItem("projectId"),
      }
      if (this.scan_name && this.scan_name.length > 0) {
        params["name"] = this.scan_name
      }
      const headers = {
        'token': localStorage.getItem("token")
      }
      this.$api.post(this.$urls.ip + this.$urls.getAutoList, params, headers)
        .then(res => {
          console.log(res.data.data)
          this.li_Scene = res.data.data["list"]
          this.total = res.data.data.total
          this.init_View()
        })
        .catch(error => {
          console.log(error)
          if (error) {
            this.$message.error("获取联动信息失败")
          }
        })
    },
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.getScene()
  },
  computed: {  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true
        if (this.scan_name && !item.name.includes(this.scan_name)) {
          this.state = false
        }
        return this.state
      });
    },
  },
  watch: {  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
}
</script>

<style>
#scene {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.grid-box { /*表格式布局*/
  display: grid;
  grid-template-columns: repeat(auto-fill, 180px);
  grid-auto-flow: row; /*改为先列后行 column*/
  column-gap: 15px; /*行列间距*/
  row-gap: 15px;
  /*grid-template-rows: repeat(auto-fill, 300px); !*设置高度限制*!*/
}

.grid-item {
  border-radius: 8px 8px 8px 8px; /* 左上角、右上角、右下角、左下角 */
  background: linear-gradient(to bottom, #ffffff, #f2f2f2 50%, #d9d9d9 100%);
  box-shadow: 0 1px 6px #1D66DD, 0 0 10px rgba(0, 0, 0, 0.1) inset;
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/scene/sceneTlink.vue